import type { CreateTokenCardData, TokenResult } from '@stripe/stripe-js';
import type noop from 'lodash/noop';

import { useStripe } from './StripeContext';
import { useStripeElements } from './StripeElementsContext';

/**
 * Return a single function to create a stripe token. Automatically subscribes
 * to the current elements context and passes a valid element.
 */
export function useStripeCreateToken():
  | typeof noop
  | ((data: CreateTokenCardData) => Promise<TokenResult>) {
  const { stripe } = useStripe();
  const stripeElements = useStripeElements();

  return (data: CreateTokenCardData): Promise<TokenResult> => {
    if (!stripe) {
      throw new Error('Stripe cannot be found');
    }
    if (!stripeElements) {
      throw new Error('Stripe elements cannot be found');
    }
    const element = stripeElements.getElement('cardNumber');
    if (!element) {
      throw new Error('Card element cannot found');
    }
    return stripe.createToken(element, data);
  };
}
